/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { UpdateCourseActivityOrderOptions, UpdateCourseActivityOrderResponses } from '../../models/UpdateCourseActivityOrder'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Update Course Activity Order
 * {@link /admin/course/activity/:activity_id/set-order/:index}
 */
export function updateCourseActivityOrder<ThrowOnError extends boolean = true>(options: Options<UpdateCourseActivityOrderOptions, ThrowOnError>): Promise<UnwrappedResult<UpdateCourseActivityOrderResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'PUT', url: '/admin/course/activity/{activity_id}/set-order/{index}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<UpdateCourseActivityOrderResponses, ThrowOnError>>
}
